
import { toast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

export type ComponentType = {
  id: string;
  name: string;
  icon: string | null;
  group_name: string | null;
  created_at: string;
  subscription_id: string | null;
};

export const fetchComponentTypes = async (subscriptionId?: string | null) => {
  try {
    
    let query = supabase
      .from("component_types")
      .select("id, name, icon, group_name, created_at, subscription_id")
      .order("group_name")
      .order("name");
    
    // Filtrar por subscription_id se fornecido
    if (subscriptionId) {
      query = query.eq("subscription_id", subscriptionId);
    }
    
    const { data, error } = await query;
    
    if (error) {
      toast({
        title: "Erro",
        description: "Não foi possível carregar os tipos de componentes",
        variant: "destructive",
      });
      return [];
    }

    return (data || []) as ComponentType[];
  } catch (error) {
    toast({
      title: "Erro",
      description: "Ocorreu um erro ao buscar os tipos de componentes",
      variant: "destructive",
    });
    return [];
  }
};

export const createComponentType = async (name: string, icon: string | null = null, group_name: string | null = null, subscriptionId?: string | null) => {
  try {
    const { data, error } = await supabase
      .from("component_types")
      .insert([{ name, icon, group_name, subscription_id: subscriptionId }])
      .select()
      .single();
    
    if (error) {
      toast({
        title: "Erro",
        description: "Não foi possível criar o tipo de componente",
        variant: "destructive",
      });
      return null;
    }

    toast({
      title: "Sucesso",
      description: "Tipo de componente criado com sucesso",
    });
    return data as ComponentType;
  } catch (error) {
    toast({
      title: "Erro",
      description: "Ocorreu um erro ao criar o tipo de componente",
      variant: "destructive",
    });
    return null;
  }
};

export const updateComponentType = async (id: string, name: string, icon: string | null = null, group_name: string | null = null) => {
  try {
    const { data, error } = await supabase
      .from("component_types")
      .update({ name, icon, group_name })
      .eq("id", id)
      .select()
      .single();
    
    if (error) {
      toast({
        title: "Erro",
        description: "Não foi possível atualizar o tipo de componente",
        variant: "destructive",
      });
      return null;
    }

    toast({
      title: "Sucesso",
      description: "Tipo de componente atualizado com sucesso",
    });
    return data as ComponentType;
  } catch (error) {
    toast({
      title: "Erro",
      description: "Ocorreu um erro ao atualizar o tipo de componente",
      variant: "destructive",
    });
    return null;
  }
};

export const deleteComponentType = async (id: string) => {
  try {
    const { error } = await supabase
      .from("component_types")
      .delete()
      .eq("id", id);
    
    if (error) {
      toast({
        title: "Erro",
        description: "Não foi possível excluir o tipo de componente",
        variant: "destructive",
      });
      return false;
    }

    toast({
      title: "Sucesso",
      description: "Tipo de componente excluído com sucesso",
    });
    return true;
  } catch (error) {
    toast({
      title: "Erro",
      description: "Ocorreu um erro ao excluir o tipo de componente",
      variant: "destructive",
    });
    return false;
  }
};
